const en = {
  "navbar.notifications": "Notifications",
  "navbar.noNotifications": "No new notifications",
  "navbar.cookieSettings": "Cookie Settings",
  "nav.logout": "Logout",
  "nav.language": "Language",
  "nav.english": "English (US)",
  "nav.french": "French (FR)",

  "sidebar.navigation": "Navigation",
  "sidebar.mainDashboard": "Main Dashboard",
  "sidebar.home": "Home",
  "sidebar.customers": "Customers",
  "sidebar.billing": "Billing",
  "sidebar.referral": "Referral",
  "sidebar.googleReviews": "Google Reviews",
  "sidebar.flashDeals": "Flash Deals",
  "sidebar.loyaltyProgram": "Loyalty Program",
  "sidebar.analyticsInsights": "Analytics and Insights",
  "sidebar.transactionsPurchases": "Transactions and purchases",
  "sidebar.merchantApprovals": "Merchant Approvals",
  "sidebar.adminKpis": "Business KPIs",
  "sidebar.squareMerchants": "Square Merchants & Orders",
  "sidebar.customerLoyalty": "Customer Loyalty",
  "sidebar.pendingRewards": "Pending Rewards",
  "sidebar.loyaltySettings": "Loyalty Settings",
  "sidebar.users": "Users",
  "sidebar.inactiveUsers": "Inactive Users",
  "sidebar.usersList": "Users List",
  "sidebar.profile": "Profile",
  "sidebar.businesses": "Businesses",
  "sidebar.clients": "Clients",
  "sidebar.items": "Items",
  "sidebar.itemsPurchased": "Items Purchased",
  "sidebar.purchaseHistory": "Purchase History",
  "sidebar.receiptsHistory": "Receipts History",
  "sidebar.churnRate": "Churn Rate",
  "sidebar.itemsOverview": "Items overview",
  "sidebar.netPromoterScore": "Net Promoter Score",
  "sidebar.increasedMarginChart": "Increased Margin Chart",
  "sidebar.repeatPurchase": "Repeat Purchase",
  "sidebar.revenueGraph": "Revenue Graph",

  "dashboard.dashboard": "Dashboard",
  "dashboard.customers": "Customers",
  "dashboard.customers.compareMessage": "Since last month",
  "dashboard.orders": "Orders",
  "dashboard.revenue": "Revenue",
  "dashboard.growth": "Growth",
  "dashboard.HighPerformingProducts": "High Performing Products",
  "dashboard.Sales": "Sales",

  "merchantsData.title": "Square Merchants & Order",
  "merchantsData.merchantsList": "Merchants List",
  "merchantsData.selectMerchant": "Select Merchant",
  "merchantsData.payments": "Payments",
  "merchantsData.viewDetails": "Select a merchant to view details",
  "merchantsData.notFound": "No merchants found",
  "merchantsData.noSquareMerchant":
    'No Square merchant account linked. Please use "Login with Square" on the dashboard to connect your account.',
  "merchantsData.merchantDetail.id": "Merchant ID",
  "merchantsData.merchantDetail.country": "Country",
  "merchantsData.merchantDetail.currency": "Currency",
  "merchantsData.merchantDetail.statistics": "Statistics:",
  "merchantsData.merchantDetail.totalPayments": "Total Payments",
  "merchantsData.merchantDetail.totalOrders": "Total Orders",
  "merchantsData.merchantDetail.user": "User",
  "merchantsData.merchantDetail.paymentId": "Payment ID:",
  "merchantsData.merchantDetail.amount": "Amount:",
  "merchantsData.merchantDetail.status": "Status:",
  "merchantsData.merchantDetail.nopaymentsfound": "No payments found",
  "merchantsData.merchantDetail.orderId": "Order ID:",
  "merchantsData.merchantDetail.items": "items",
  "merchantsData.merchantDetail.noOrdersfound": "No orders found",
  "merchantsData.paymentDetail.header": "Payment Details",
  "merchantsData.paymentDetail.paymentID": "Payment ID",
  "merchantsData.paymentDetail.orderID": "Order ID",
  "merchantsData.paymentDetail.status": "Status",
  "merchantsData.paymentDetail.tip": "Tip",
  "merchantsData.paymentDetail.Total": "Total",
  "merchantsData.paymentDetail.refunded": "Refunded",
  "merchantsData.paymentDetail.card": "Card",
  "merchantsData.paymentDetail.customerID": "Customer ID",
  "merchantsData.paymentDetail.email": "Email",
  "merchantsData.paymentDetail.createdAt": "Created At",
  "merchantsData.paymentDetail.orderItems": "Order Items",
  "merchantsData.paymentDetail.itemName": "Item Name",
  "merchantsData.paymentDetail.quantity": "Quantity",
  "merchantsData.paymentDetail.price": "Price",
  "merchantsData.paymentDetail.itemID": "Item ID",
  "merchantsData.paymentDetail.variation": "Variation",
  "merchantsData.paymentDetail.TotalMerchants": "Total Merchants: {{number}}",

  "customerLoyalty.header": "Customer Loyalty",
  "customerLoyalty.totalPoints": "Total Points:",
  "customerLoyalty.hidePurchaseHistory": "Hide Purchase History",
  "customerLoyalty.showPurchaseHistory": "Show Purchase History",
  "customerLoyalty.paymentState": "Payment State",
  "customerLoyalty.title": "Title",
  "customerLoyalty.createdTime": "Created Time",
  "customerLoyalty.nodata": "No customer data found",

  "validateRewards.header": "All Rewards",
  "validateRewards.selectMerchant": "Select Merchant",
  "validateRewards.createReward": "Create Reward",
  "validateRewards.autoRefreshing": "Auto-refreshing every 3s",
  "validateRewards.loading": "Loading...",
  "validateRewards.loadingRewards": "Loading rewards...",
  "validateRewards.debugInfo": "Debug Info",
  "validateRewards.debugInformation": "Debug Information",
  "validateRewards.MerchantFound": "Merchant Found",
  "validateRewards.BusinessName": "Business Name",
  "validateRewards.totalrewards": "Total Rewards (all statuses)",
  "validateRewards.statusBreakdown": "Status Breakdown: Pending",
  "validateRewards.Validated": "Validated",
  "validateRewards.Redeemed": "Redeemed",
  "validateRewards.Expired": "Expired",
  "validateRewards.TotalUserRewards": "Total User Rewards",
  "validateRewards.message":
    "Rewards will appear here when customers create or validate them.",
  "validateRewards.NoRewards": "No Rewards",
  "validateRewards.Customer": "Customer",
  "validateRewards.Reward": "Reward",
  "validateRewards.Points": "Points",
  "validateRewards.Created": "Created",
  "validateRewards.ExpiresIn": "Expires In",
  "validateRewards.Action": "Action",
  "validateRewards.Notimestamp": "No timestamp",
  "validateRewards.Validate": "Validate",
  "validateRewards.Expire": "Expire",
  "validateRewards.Redeeming": "Redeeming...",
  "validateRewards.Redeem": "Redeem",
  "validateRewards.Pending": "Pending",
  "validateRewards.Awaitingvalidation": "Awaiting validation",
  "validateRewards.Awaitingredemption": "Awaiting redemption",
  "validateRewards.Completed": "Completed",
  "validateRewards.Nolongervalid": "No longer valid",
  "validateRewards.CreateNewReward": "Create New Reward",
  "validateRewards.Optional": "Optional",
  "validateRewards.Loadingcustomers": "Loading customers...",
  "validateRewards.Selectcustomer":
    "Select customer (or leave blank for yourself)...",
  "validateRewards.selectcustomers":
    "Select a customer who has rewards with this merchant. Leave blank to create reward for yourself.",
  "validateRewards.RewardType": "Reward Type",
  "validateRewards.Selectrewardtype": "Select reward type...",
  "validateRewards.FreeCoffee": "Free Coffee",
  "validateRewards.Off": "Off",
  "validateRewards.FreeItem": "Free Item",
  "validateRewards.PercentageOff": "Percentage Off",
  "validateRewards.PointsUsed": "Points Used",
  "validateRewards.pointsused":
    "Number of points used to obtain this reward (default:0)",
  "validateRewards.Cancel": "Cancel",
  "validateRewards.Creating": "Creating...",

  "loyaltyView.header": "Loyalty Settings",
  "loyaltyView.Loadingsettings": "Loading settings...",
  "loyaltyView.PointsperDollar": "Points per Dollar",
  "loyaltyView.MinimumOrderAmount": "Minimum Order Amount",
  "loyaltyView.PointsperOrder": "Points per Order",
  "loyaltyView.PointsperItem": "Points per Item",
  "loyaltyView.BonusThreshold": "Bonus Threshold",
  "loyaltyView.BonusPoints": "Bonus Points",
  "loyaltyView.Save": "Save",
  "loyaltyView.Edit": "Edit",

  "newusers.header": "Inactive Users",
  "newusers.Username": "Username",
  "newusers.Active": "Active",
  "usersLists.header": "Users",
  "usersLists.Options": "Options",
  "usersLists.Deactivate": "Deactivate",
  "usersLists.Delete": "Delete",

  "merchantApprovals.header": "Pending Merchants List",

  "adminKpis.title": "Business KPI Dashboard",
  "adminKpis.generatedAt": "Data as of",
  "adminKpis.overview": "Top-level metrics",
  "adminKpis.userMetrics": "User metrics",
  "adminKpis.merchantBreakdown": "Merchant breakdown",
  "adminKpis.loading": "Loading KPI data…",
  "adminKpis.failedToLoad": "Failed to load KPI dashboard.",
  "adminKpis.noMerchants": "No merchants found.",
  "adminKpis.totalMerchants": "Total merchants",
  "adminKpis.paid": "Paid",
  "adminKpis.trial": "Trial",
  "adminKpis.churned": "Churned",
  "adminKpis.totalLocations": "Total locations",
  "adminKpis.totalUsers": "Total registered users",
  "adminKpis.mrr": "MRR",
  "adminKpis.tapsAllTime": "Total taps (all-time)",
  "adminKpis.tapsThisWeek": "Taps this week",
  "adminKpis.tapsThisMonth": "Taps this month",
  "adminKpis.avgTapsPerMerchant": "Avg taps / merchant / month",
  "adminKpis.trialToPaid": "Trial → paid (of trials ended)",
  "adminKpis.churnRate": "Churn rate (% of paid who cancelled)",
  "adminKpis.newUsersWeek": "New users this week",
  "adminKpis.users2PlusVisits": "Users with 2+ visits",
  "adminKpis.usersActiveProgress": "Active reward progress",
  "adminKpis.usersClaimedReward": "Claimed ≥1 reward",
  "adminKpis.colName": "Merchant",
  "adminKpis.colLocation": "Location",
  "adminKpis.colStatus": "Status",
  "adminKpis.colTrialEnd": "Trial end",
  "adminKpis.colTotalTaps": "Total taps",
  "adminKpis.colTaps7d": "Taps (7d)",
  "adminKpis.colUniqueUsers": "Unique users",
  "adminKpis.colRewards": "Rewards claimed",
  "adminKpis.colLastTap": "Last tap",
  "adminKpis.status.paid": "Paid",
  "adminKpis.status.trial": "Trial",
  "adminKpis.status.churned": "Churned",
  "adminKpis.status.other": "Other",

  "businesses.header": "Businesses",
  "businesses.Add": "Add",
  "businesses.ID": "ID",
  "businesses.Name": "Name",
  "businesses.Contact": "Contact",
  "businesses.Update": "Update",

  "clients.header": "Clients",
  "clients.Age": "Age",
  "clients.Address": "Address",
  "clients.Gender": "Gender",
  "clients.Business": "Business",
  "clients.DOB": "DOB",
  "clients.PurchaseDetails": "Purchase Details",
  "clients.Details": "Details",
  "itemsPurchased.header": "Items Purchased",
  "itemsPurchased.AddItemPurchased": "Add Item Purchased",
  "itemsPurchased.PurchaseHistoryID": "Purchase History ID",
  "itemsPurchased.ItemName": "Item Name",
  "itemsPurchased.Quantity": "Quantity",

  "purchaseHistory.header": "Purchase History",
  "purchaseHistory.AddPurchase": "Add Purchase",
  "purchaseHistory.Client": "Client",
  "purchaseHistory.Date": "Date",
  "purchaseHistory.Time": "Time",
  "purchaseHistory.TotalAmount": "Total Amount",

  "receiptsHistory.header": "Receipts History",
  "receiptsHistory.AddReceipt": "Add Receipt",
  "receiptsHistory.AccountNumber": "Account Number",
  "receiptsHistory.TransactionDate": "Transaction Date",
  "receiptsHistory.Company": "Company",
  "receiptsHistory.PaymentAmount": "Payment Amount",
  "receiptsHistory.PaymentType": "Payment Type",
  "receiptsHistory.Plan": "Plan",

  "customerChurnRate.header": "Customer Churn Rate",
  "customerChurnRate.chartTitle": "Customer Churn Rate",

  "itemsSoldDetails.header": "Items Sold Details",
  "itemsSoldDetails.MostSoldItem": "Most Sold Item",
  "itemsSoldDetails.LeastSoldItem": "Least Sold Item",
  "itemsSoldDetails.MostBuyingAgeGroup": "Most Buying Age Group",
  "itemsSoldDetails.chartTitle": "Purchases by Hour of the Day",
  "itemsSoldDetails.PurchasesbyHour": "Purchases by Hour",

  "nPSChart.header": "Net Promoter Score (NPS)",
  "nPSChart.Promoters": "Promoters",
  "nPSChart.Passives": "Passives",
  "nPSChart.Detractors": "Detractors",
  "nPSChart.SurveyRespondents": "Survey Respondents",
  "nPSChart.NumberofRespondents": "Number of Respondents",
  "nPSChart.Respondents": "Respondents",
  "nPSChart.chartTitle": "Net Promoter Score: {{score}}",

  "increasedMarginChart.header": "Increased Margin (High Value Products)",
  "increasedMarginChart.Products": "Products",
  "increasedMarginChart.MarginContributionpercentage":
    "Margin Contribution (%)",
  "increasedMarginChart.IncreasedMargin": "Increased Margin by Product",
  "increasedMarginChart.MarginContribution": "Margin Contribution",
  "RepeatPurchaseRateGraph.header": "Repeat Purchase Rate",
  "RepeatPurchaseRateGraph.RepeatClients": "Repeat Clients",
  "RepeatPurchaseRateGraph.SinglePurchaseClients": "Single Purchase Clients",
  "squareLogin.buttonTitle": "Login with Square",

  "home.punchCardRewards": "Your punch-card rewards",
  "home.programDescDefault": "Add one or more rewards. Each is stored under your merchant catalog.",
  "home.addFirstReward": "Add your first reward",
  "home.programDescNoRewards": "Create a reward customers can earn with visits.",
  "home.rewardsInCatalog_one": "{{count}} reward in your catalog.",
  "home.rewardsInCatalog_other": "{{count}} rewards in your catalog.",

  "home.merchantAdminView": "Merchant (admin view)",
  "home.selectMerchant": "Select a merchant…",
  "home.visitsThisMonth": "Visits This Month",
  "home.uniqueCustomers": "Unique Customers",
  "home.rewardsRedeemed": "Rewards Redeemed",
  "home.repeatRate": "Repeat Rate",
  "home.googleReviewsGenerated": "Google reviews generated through Klerk",
  "home.googleReviewsTotal": "Total requests received",
  "home.googleReviewsApproved": "Total approved",
  "home.googleReviewsDeclined": "Total declined",
  "home.oneVisitAway": "Customers 1 Visit Away from a Reward",
  "home.twoVisitsAway": "Customers 2 Visits Away from a Reward",
  "home.viewCustomers": "View Customers",
  "home.recentActivity": "Recent Activity",
  "home.loading": "Loading…",
  "home.noActivity": "No activity yet. Visits, points, and redemptions will appear here.",
  "home.viewAllActivity": "View All Activity",
  "home.yourRewardProgram": "Your Reward Program",
  "home.catalogSynced": "Catalog synced",
  "home.notSavedYet": "Not saved yet",
  "home.noRewardsYet": "No rewards yet — use \"Add a reward\" below.",
  "home.reward": "Reward",
  "home.visitsRequired": "Visits required",
  "home.visits": "visits",
  "home.saving": "Saving…",
  "home.save": "Save",
  "home.cancel": "Cancel",
  "home.edit": "Edit",
  "home.removing": "Removing…",
  "home.remove": "Remove",
  "home.customerSelections": "Customer selections",
  "home.customerSelectionsDesc": "Rewards picked in the app show here while pending. Choose another customer and Save to reassign.",
  "home.noPendingRedemptions": "No pending or in-progress redemptions.",
  "home.customer": "Customer",
  "home.selectCustomer": "Select customer…",
  "home.currentPrefix": "Current: ",
  "home.adding": "Adding…",
  "home.addReward": "Add reward",
  "home.enterRewardType": "Enter reward type",
  "home.close": "Close",
  "home.addAReward": "Add a reward",
  "home.nfcStand": "NFC Stand:",
  "home.nfcActive": "Active",
  "home.allActivity": "All activity",
  "home.noActivityModal": "No activity yet. Reward redemptions, synced visits, and points from purchases will show here.",

  "loyaltySettings.merchantAdmin": "Merchant (admin)",
  "loyaltySettings.selectMerchant": "Select a merchant…",
  "loyaltySettings.loading": "Loading…",
  "loyaltySettings.rewardType": "Reward type",
  "loyaltySettings.rewardTypePlaceholder": "Enter reward type",
  "loyaltySettings.visitsRequired": "Visits required",
  "loyaltySettings.addReward": "Add reward",
  "loyaltySettings.adding": "Adding…",

  "billing.subtitle": "Klerk merchant subscription billing.",

  "referral.description": "Invite merchants and earn a free month after they complete the onboarding process and subscribe.",
  "referral.loading": "Loading referral stats...",
  "referral.yourLink": "Your referral link",
  "referral.copyLink": "Copy link",
  "referral.shareEmail": "Share via Email",
  "referral.shareX": "Share on X",
  "referral.shareLinkedIn": "Share on LinkedIn",
  "referral.copied": "Referral link copied",
  "referral.copyFailed": "Could not copy link",
  "referral.clicks": "Clicks",
  "referral.referrals": "Referrals",
  "referral.rewardsEarned": "Rewards earned",
  "referral.alerts": "Dashboard alerts",
  "referral.noAlerts": "No alerts yet.",

  "googleReviews.title": "Google Reviews",
  "googleReviews.description": "Approve bonus visit requests from customers who left a Google review.",
  "googleReviews.loading": "Loading review requests...",
  "googleReviews.failedToLoad": "Failed to load review requests.",
  "googleReviews.noPending": "No pending review requests.",
  "googleReviews.requestedOn": "Requested",
  "googleReviews.approve": "Approve",
  "googleReviews.decline": "Decline",
  "googleReviews.processing": "Processing…",
  "googleReviews.approvedSuccess": "Review approved — bonus visit added.",
  "googleReviews.declinedSuccess": "Review request declined.",
  "googleReviews.actionFailed": "Could not update review request.",
  "googleReviews.pendingBadge": "{{count}} pending review requests",

  "flashDeals.title": "Flash Deals",
  "flashDeals.description": "Post a time-limited promotion your customers can claim in the Klerk app.",
  "flashDeals.newDeal": "New flash deal",
  "flashDeals.item": "Item",
  "flashDeals.itemPlaceholder": "e.g. Large latte",
  "flashDeals.deal": "Deal",
  "flashDeals.dealPlaceholder": "e.g. 20% off, or buy one get one free",
  "flashDeals.validFor": "Valid for",
  "flashDeals.days": "{{count}} day",
  "flashDeals.days_plural": "{{count}} days",
  "flashDeals.uploadPhoto": "Upload photo",
  "flashDeals.uploading": "Uploading…",
  "flashDeals.uploadFailed": "Could not upload photo. Please try again.",
  "flashDeals.imageAlt": "Flash deal",
  "flashDeals.remove": "Remove",
  "flashDeals.publish": "Publish",
  "flashDeals.publishing": "Publishing…",
  "flashDeals.posted": "Your flash deal has been published.",
  "flashDeals.postFailed": "Something went wrong. Please try again.",
  "flashDeals.missingMerchant": "Could not determine your business account. Please refresh the page and try again.",
  "flashDeals.loading": "Loading flash deals…",
  "flashDeals.loadFailed": "Could not load flash deals.",
  "flashDeals.noDeals": "No flash deals yet. Post your first promotion!",
  "flashDeals.expired": "Expired",
  "flashDeals.expiresIn": "Expires in {{count}} day",
  "flashDeals.expiresIn_plural": "Expires in {{count}} days",
  "flashDeals.delete": "Delete",
  "flashDeals.deleting": "Deleting…",
  "flashDeals.confirmDelete": "Delete this flash deal? This cannot be undone.",
  "flashDeals.deleteFailed": "Could not delete flash deal. Please try again.",

  "customers.lead": "Phone, loyalty ID, visits and points needed for the next reward, redemptions, and last activity — synced from your loyalty app.",
  "customers.merchantAdmin": "Merchant (admin)",
  "customers.chooseStore": "Choose which store's customer list to view.",
  "customers.selectMerchant": "Select a merchant…",
  "customers.selectFirst": "Select a merchant to view customers.",
  "customers.noCustomers": "No customers yet. When shoppers tap at your location or sync the app, they will appear here.",
  "customers.sortLastVisit": "Sort: Last visit",
  "customers.sortClosestReward": "Sort: Closest to reward",
  "customers.details": "Details",

  "profile.title": "Merchant Profile",
  "profile.active": "Active",
  "profile.logOut": "Log out",
  "profile.editProfile": "Edit Profile",
  "profile.saveChanges": "Save Changes",
  "profile.saving": "Saving...",
  "profile.cancel": "Cancel",
  "profile.businessInformation": "Business Information",
  "profile.languagePreference": "Language Preference",
  "profile.cookieSettings": "Cookie Settings",
  "profile.deleteAccount": "Delete Account",
  "profile.accountEmail": "Account Email",
  "profile.businessName": "Business Name",
  "profile.address": "Address",
  "profile.category": "Category",
  "profile.phone": "Phone",
  "profile.notProvided": "Not provided",
  "profile.enterBusinessName": "Enter business name",
  "profile.enterAddress": "Enter business address",
  "profile.selectCategory": "Select a category",
  "profile.enterPhone": "Enter phone number",
  "profile.emailLoginNote": "Your account email (used for login)",
  "profile.displayLanguage": "Display language",
  "profile.chooseLanguage": "Choose your preferred language",
  "profile.language": "Language",
  "profile.manageCookies": "Manage your cookie preferences",
  "profile.deleteAccountQuestion": "Are you sure that you want to delete your account?",
  "profile.deleting": "Deleting...",
  "profile.loadingProfile": "Loading merchant profile...",
  "profile.noBusinessFound": "No business profile found. Please complete the onboarding wizard first.",
  "profile.failedToLoad": "Failed to load merchant profile. Please try again.",
  "profile.failedToSave": "Failed to save profile. Please try again.",
  "profile.requiredFields": "Business name, address, category, and phone are required.",
  "profile.updateSuccess": "Profile updated successfully!",
  "profile.loggedOut": "You have been logged out successfully.",
  "profile.deleteConfirm": "This will permanently delete your account. Do you want to proceed?",
  "profile.failedToDelete": "Failed to delete account. Please try again.",
  "profile.googlePlaceId": "Google Place ID",
  "profile.googlePlaceIdPlaceholder": "Paste your Google Place ID",
  "profile.googlePlaceIdHint": "Enables the Google review prompt on your customer web form.",
  "profile.freeVisitForReview": "Offer a free visit to customers who leave a Google review",
  "profile.yes": "Yes",
  "profile.no": "No",

  "login.header": "Login",
  "login.createAccount": "Don't have an Account? Create your Account",
  "login.text": "text",
  "login.password": "password",
  "login.ForgotPassword": "Forgot Password?",
  "login.Signup": "Sign up",
  "login.signupwith": "Or sign up with",
  "login.WelcomeBack": "Welcome Back!",
  "login.clickingsignupbutton":
    "Simply create your account by clicking the signup button!",

  "onboarding.step": "Step {{step}} of {{total}}",
  "onboarding.screen0.title": "Create your merchant account",
  "onboarding.screen0.email": "Email",
  "onboarding.screen0.password": "Password",
  "onboarding.screen0.passwordPlaceholder": "Min 8 chars with uppercase, lowercase, number, and a symbol",
  "onboarding.screen0.weak": "Weak",
  "onboarding.screen0.fair": "Fair",
  "onboarding.screen0.strong": "Strong",
  "onboarding.screen0.req1": "✓ At least 8 characters",
  "onboarding.screen0.req2": "✓ Mix of uppercase & lowercase",
  "onboarding.screen0.req3": "✓ One number",
  "onboarding.screen0.req4": "✓ One symbol (e.g. ! @ # $)",
  "onboarding.screen0.terms": "By continuing, you agree to our",
  "onboarding.screen0.termsLink": "Terms & Conditions",
  "onboarding.screen0.and": "and",
  "onboarding.screen0.privacyLink": "Privacy Policy",
  "onboarding.screen0.invalidEmail": "Enter a valid email to continue.",
  "onboarding.screen0.passwordWeak": "Complete all password requirements to continue.",
  "onboarding.screen0.creating": "Creating account...",
  "onboarding.screen0.continue": "Continue",
  "onboarding.screen0.backToLogin": "Already have an account? Back to Login →",
  "onboarding.screen1.title": "Tell us about your business",
  "onboarding.screen1.titleEdit": "Edit your business information",
  "onboarding.screen1.subtitle": "This helps us personalize your experience.",
  "onboarding.screen1.subtitleEdit": "Update your business details below.",
  "onboarding.screen1.businessName": "Business Name",
  "onboarding.screen1.businessNamePlaceholder": "e.g. Sunny Café",
  "onboarding.screen1.address": "Business Address",
  "onboarding.screen1.addressPlaceholder": "Start typing your address...",
  "onboarding.screen1.addressTip": "💡 Tip: Our team will integrate Google Places autocomplete here",
  "onboarding.screen1.category": "Category",
  "onboarding.screen1.selectCategory": "Select a category",
  "onboarding.screen1.phone": "Business Phone",
  "onboarding.screen1.phonePlaceholder": "+1 (555) 000-0000",
  "onboarding.screen1.googlePlaceId": "Google Place ID",
  "onboarding.screen1.googlePlaceIdPlaceholder": "Paste your Google Place ID",
  "onboarding.screen1.googlePlaceIdHint": "Enables the Google review prompt on your customer web form.",
  "onboarding.screen1.freeVisitForReview": "Offer a free visit to customers who leave a Google review",
  "onboarding.screen2.title": "Create your digital punch card",
  "onboarding.screen2.titleEdit": "Edit your digital punch card",
  "onboarding.screen2.subtitle": "Set the reward your customers will love.",
  "onboarding.screen2.subtitleEdit": "Update your reward settings below.",
  "onboarding.screen2.buy": "Buy",
  "onboarding.screen2.visits": "visits → Get",
  "onboarding.screen2.visitsLabel": "Number of visits required",
  "onboarding.screen2.rewardDesc": "Reward description",
  "onboarding.screen2.rewardDescPlaceholder": "e.g. 1 free item",
  "onboarding.screen2.rewardType": "Reward type",
  "onboarding.screen2.rewardTypePlaceholder": "e.g. Free item, Free coffee, 10% off",
  "onboarding.screen3.title": "Start your 30-day free trial",
  "onboarding.screen3.subtitle": "No charge today. Cancel anytime.",
  "onboarding.screen3.stripeSecure": "Secure payment powered by Stripe",
  "onboarding.screen3.enterPayment": "Enter payment details",
  "onboarding.screen3.loading": "Loading...",
  "onboarding.screen3.mockHint": "Using mock API - will connect to real Stripe later",
  "onboarding.screen3.creatingSession": "Creating checkout session...",
  "onboarding.screen4.title": "Your punch card is live!",
  "onboarding.screen4.titleEdit": "Your changes are saved!",
  "onboarding.screen4.subtitle": "Here's what's set up for",
  "onboarding.screen4.subtitleEdit": "Here's what's updated for",
  "onboarding.screen4.reward": "Reward",
  "onboarding.screen4.buy": "Buy",
  "onboarding.screen4.get": "→ Get",
  "onboarding.screen4.type": "Type",
  "onboarding.screen4.businessId": "Business ID",
  "onboarding.screen4.nfcStand": "NFC Stand",
  "onboarding.screen4.nfcDelivery": "Delivered within 24 hours",
  "onboarding.screen4.checklist": "Get started checklist",
  "onboarding.screen4.check1": "Place your NFC stand",
  "onboarding.screen4.check2": "Tell staff to say: \"Tap to earn points.\"",
  "onboarding.screen4.check3": "Get your first 10 customers tapping",
  "onboarding.screen4.goToDashboard": "Go to Dashboard →",
  "onboarding.screen4.backToProfile": "Back to Profile →",
  "onboarding.back": "Back",
  "onboarding.next": "Next",
  "onboarding.saving": "Saving...",

  "forgotPassword.header": "Forgot Password",
  "forgotPassword.subtext": "Enter your business email and we'll send you a reset link.",
  "forgotPassword.placeholder": "Enter your email",
  "forgotPassword.sendLink": "Send Reset Link",
  "forgotPassword.backToLogin": "Back to login",
  "forgotPassword.rightTitle": "Back to login page",
  "forgotPassword.rightText": "Remembered your password? Sign in to continue managing your business.",
  "forgotPassword.successMsg": "Password reset email sent! Please check your inbox.",
  "forgotPassword.errorMsg": "Failed to send password reset email. Please try again.",

  "resetPassword.header": "Reset Password",
  "resetPassword.newPassword": "New password",
  "resetPassword.confirmPassword": "Confirm new password",
  "resetPassword.submit": "Reset password",
  "resetPassword.backToLogin": "Back to login",
  "resetPassword.rightTitle": "Back to login page",
  "resetPassword.invalidLink": "Invalid password reset link. Please request a new one.",
  "resetPassword.mismatch": "Passwords do not match.",
  "resetPassword.success": "Password has been reset successfully! You can now log in.",
  "resetPassword.error": "Failed to reset password. The link may have expired. Please request a new one.",
  "resetPassword.subtext": "Choose a new password for your account.",
  "resetPassword.rightText": "Remembered your password? Sign in to continue managing your business.",
  // customers
  "customers.phone": "Phone",
  "customers.loyaltyId": "Loyalty ID",
  "customers.visitsToNext": "Visits to next reward",
  "customers.rewardsRedeemed": "Rewards redeemed",
  "customers.lastVisit": "Last visit",
  "customers.count_one": "{{count}} customer",
  "customers.count_other": "{{count}} customers",
  "customers.defaultStore": "Store",

  "billing.yourSubscription": "Your subscription",
  "billing.status": "Status",
  "billing.currentPlan": "Current plan",
  "billing.nextBillingDate": "Next billing date",
  "billing.firstCharge": "First charge (after trial)",
  "billing.manageBilling": "Manage billing",
  "billing.opening": "Opening…",
  "billing.redirecting": "Redirecting…",
  "billing.stripeHint": "Opens Stripe Customer Portal to update card, view invoices, or cancel.",
  "billing.noSubscription": "No active subscription",
  "billing.statusActive": "Active",
  "billing.statusTrial": "Active · Free trial",
  "billing.statusPastDue": "Past due",
  "billing.statusCanceled": "Canceled",
  "billing.statusUnpaid": "Unpaid",
  "billing.trialLabel": "· free trial",
  "billing.loadingStore": "Loading your store…",
  "billing.finishSetup": "Finish setting up your business to view billing and start your free trial.",
  "billing.completeSetup": "Complete setup",
  "billing.enterEmail": "Enter the email address you use for this account so we can connect your subscription in Stripe.",
  "billing.emailLabel": "Email for billing",
  "billing.emailPlaceholder": "you@example.com",
  "billing.checkoutSuccess": "Your subscription is active. Trial details and your first charge date are below.",
  "billing.checkoutWarn": "If Manage billing still fails, confirm you are logged in with the same email used in Stripe.",
  "billing.yourStore": "Your store",
  "billing.defaultPlan": "Your plan",
  "billing.klerkSubscription": "Klerk subscription",

  "validateRewards.confirmExpire": "Are you sure you want to expire this reward?",

  "customers.modal.title": "Customer details",
  "customers.modal.phone": "Phone",
  "customers.modal.loyaltyId": "Loyalty ID",
  "customers.modal.visitCount": "Visit count",
  "customers.modal.visitsToNext": "Visits to next reward",
  "customers.modal.totalRedeemed": "Total rewards redeemed",
  "customers.modal.lastVisit": "Last visit",
  "customers.modal.lastRedemption": "Last redemption",
  "customers.modal.redemptionHistory": "Redemption history",
  "customers.modal.redemptionDesc": "Totals from the customer's app: how many rewards they've used overall and when they last claimed one. Recent visits and redemptions also appear in the activity list below.",
  "customers.modal.lifetimeRedemptions": "Lifetime redemptions:",
  "customers.modal.lastRewardClaimed": "Last reward claimed at:",
  "customers.modal.noRedemptionHistory": "No redemption history for this store yet.",
  "customers.modal.recentActivity": "Recent activity",
  "customers.modal.noActivity": "No recent visits or taps to show yet.",
  "customers.modal.when": "When",
  "customers.modal.type": "Type",
  "customers.modal.notes": "Notes",
  "customers.modal.recorded": "Recorded",
  "customers.modal.redemptionRelated": "Redemption-related",
  "customers.modal.visitOther": "Visit / other",
  "customers.modal.close": "Close",

  "clients.deleteConfirm": "Are you sure you want to delete this client ?",

  "home.removeConfirm": "Remove this reward from your program ?",
  "usersLists.deleteConfirm": "Are you sure you want to delete this user?",
};

export default en;
